/* eslint-disable */
import type { DataNode } from 'antd/lib/tree';
import { parse } from 'querystring';
import BigNumber from 'bignumber.js';
import { useEffect, useState } from 'react';
import { message } from 'antd';
import Locale from '@/locales/chat';

export const LoginPageUrl = '/user/login';
// export const LoginPageUrl = SSOServer ? `${SSOServer}/login` : '';

const reg =
  /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/;

export const isUrl = (path: string): boolean => reg.test(path);

export const isAntDesignPro = (): boolean => {
  if (ANT_DESIGN_PRO_ONLY_DO_NOT_USE_IN_YOUR_PRODUCTION === 'site') {
    return true;
  }
  return window.location.hostname === 'preview.pro.ant.design';
};

// 给官方演示站点用，用于关闭真实开发环境不需要使用的特性
export const isAntDesignProOrDev = (): boolean => {
  const { NODE_ENV } = process.env;
  if (NODE_ENV === 'development') {
    return true;
  }
  return isAntDesignPro();
};

export function trim(x: string) {
  return x.replace(/^\s+|\s+$/gm, '');
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function buildTreeData(
  data: any[],
  id: string,
  name: string,
  parentId: string,
  parentName: string,
  children: string,
) {
  const config = {
    id: id || 'id',
    name: name || 'name',
    parentId: parentId || 'parentId',
    parentName: parentName || 'parentName',
    childrenList: children || 'children',
  };

  const childrenListMap = {};
  const nodeIds = {};
  const tree: any[] = [];
  data.forEach((item: { id: string; name: string; key: string; title: string; value: any }) => {
    const d = item;
    const pId = d[config.parentId];
    if (childrenListMap[pId] == null) {
      childrenListMap[pId] = [];
    }
    d.key = d[config.id];
    d.title = d[config.name];
    d.value = d[config.id];
    nodeIds[d[config.id]] = d;
    childrenListMap[pId].push(d);
  });

  data.forEach((item: any) => {
    const d = item;
    const pId = d[config.parentId];
    if (nodeIds[pId] == null) {
      d[config.parentName] = '';
      tree.push(d);
    }
  });

  tree.forEach((t: any) => {
    adaptToChildrenList(t);
  });

  function adaptToChildrenList(item: any) {
    const o = item;
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]];
    }
    if (o[config.childrenList]) {
      o[config.childrenList].forEach((child: any) => {
        const c = child;
        c[config.parentName] = o[config.name];
        adaptToChildrenList(c);
      });
    }
  }
  return tree;
}

export const getPageQuery = () => parse(window.location.href.split('?')[1]);

export function formatTreeSelectData(arrayList: any): DataNode[] {
  const treeSelectData: DataNode[] = arrayList.map((item: any) => {
    const node: DataNode = {
      id: item.id,
      title: item.label,
      key: item.id,
      value: item.id,
    } as DataNode;
    if (item.children) {
      node.children = formatTreeSelectData(item.children);
    }
    return node;
  });
  return treeSelectData;
}

export function download(fileName: string) {
  window.location.href = `/waterbase/common/download?fileName=${encodeURI(
    fileName,
  )}&delete=${true}`;
}

export function getParentIds(key: any, treeData: any) {
  // 深度遍历查找
  function dfs(treeData2: any, key2: any, parents: any) {
    // eslint-disable-next-line
    for (let i = 0; i < treeData2.length; i++) {
      const item = treeData2[i];
      // 找到id则返回父级id
      if (item.key === key2) {
        parents.push(item.title);
        return parents;
      }
      // children不存在或为空则不递归
      // eslint-disable-next-line
      if (!item.children || !item.children.length) continue;
      // 往下查找时将当前id入栈
      parents.push(item.title);

      if (dfs(item.children, key2, parents).length) return parents;
      // 深度遍历查找未找到时当前id 出栈
      parents.pop();
    }
    // 未找到时返回空数组
    return [];
  }

  return dfs(treeData, key, []);
}
export function getParentKeys(key: any, treeData: any) {
  // 深度遍历查找
  function dfs(treeData2: any, key2: any, parents: any) {
    // eslint-disable-next-line
    for (let i = 0; i < treeData2.length; i++) {
      const item = treeData2[i];
      // 找到id则返回父级id
      if (item.key === key2) {
        parents.push(item.key);
        return parents;
      }
      // children不存在或为空则不递归
      // eslint-disable-next-line
      if (!item.children || !item.children.length) continue;
      // 往下查找时将当前id入栈
      parents.push(item.key);

      if (dfs(item.children, key2, parents).length) return parents;
      // 深度遍历查找未找到时当前id 出栈
      parents.pop();
    }
    // 未找到时返回空数组
    return [];
  }

  return dfs(treeData, key, []);
}
export function getParentParams(key: any, treeData: any) {
  // 深度遍历查找
  function dfs(treeData2: any, key2: any, parents: any) {
    // eslint-disable-next-line
    for (let i = 0; i < treeData2.length; i++) {
      const item = treeData2[i];
      // 找到id则返回父级id
      if (item.key === key2) {
        parents[item.type] = item.title;
        // parents.push(item.key);
        break;
      }
      // children不存在或为空则不递归
      // eslint-disable-next-line
      if (!item.children || !item.children.length) {
        continue;
      }
      // 往下查找时将当前id入栈
      // parents.push(item.key);
      parents[item.type] = item.title;
      const length = Object.keys(parents).length;
      const obj = dfs(item.children, key2, parents);
      if (Object.keys(obj).length > length) {
        break;
      } else {
        delete parents[item.type];
        continue;
      }
      // 深度遍历查找未找到时当前id 出栈
      // parents.pop();
    }
    // 未找到时返回空数组
    return parents;
  }
  return dfs(treeData, key, {});
}

export const DropHandle = (info: any, treeData: any[]) => {
  const dropKey = info.node.key;
  const dragKey = info.dragNode.key;
  const dropPos = info.node.pos.split('-');
  const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);

  const loop = (data: any, key: any, callback: any) => {
    for (let i = 0; i < data.length; i += 1) {
      if (data[i].key === key) {
        return callback(data[i], i, data);
      }
      if (data[i].children) {
        loop(data[i].children, key, callback);
      }
    }
    return '';
  };
  const data = JSON.parse(JSON.stringify(treeData));

  // Find dragObject
  let dragObj: any;
  loop(data, dragKey, (item: any, index: any, arr: any) => {
    arr.splice(index, 1);
    dragObj = item;
  });

  if (!info.dropToGap) {
    // Drop on the content
    loop(data, dropKey, (item: any) => {
      const item2 = item;
      item2.children = item2.children || [];
      // where to insert 示例添加到头部，可以是随意位置
      item2.children.unshift(dragObj);
    });
  } else if (
    (info.node.props.children || []).length > 0 && // Has children
    info.node.props.expanded && // Is expanded
    dropPosition === 1 // On the bottom gap
  ) {
    loop(data, dropKey, (item: any) => {
      const item2 = item;
      item2.children = item2.children || [];
      item2.children.unshift(dragObj);
    });
  } else {
    let ar: any;
    let i: any;
    loop(data, dropKey, (item: any, index: any, arr: any) => {
      ar = arr;
      i = index;
    });
    if (dropPosition === -1) {
      ar.splice(i, 0, dragObj);
    } else {
      ar.splice(i + 1, 0, dragObj);
    }
  }
  return data;
};

export const DropSameLevelHandle = (info: any, treeData: any[]) => {
  // console.log(info)
  const dropKey = info.node.key;
  const dragKey = info.dragNode.key;
  const dragPos = info.dragNode.pos.split('-');
  const dropPos = info.node.pos.split('-');
  dragPos.pop();
  dropPos.pop();
  const dragstr = dragPos.toString();
  const dropstr = dropPos.toString();
  if (dragstr !== dropstr) {
    const dropPos1 = info.node.pos.split('-');
    const dropstr1 = dropPos1.toString();
    if (!(dragstr === dropstr1 && info.dropPosition === 0 && !info.dropToGap)) {
      return [];
    }
  }
  const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);

  const loop = (data: any, key: any, callback: any) => {
    for (let i = 0; i < data.length; i += 1) {
      if (data[i].key === key) {
        return callback(data[i], i, data);
      }
      if (data[i].children) {
        loop(data[i].children, key, callback);
      }
    }
    return '';
  };
  const data = JSON.parse(JSON.stringify(treeData));

  // Find dragObject
  let dragObj: any;
  loop(data, dragKey, (item: any, index: any, arr: any) => {
    arr.splice(index, 1);
    dragObj = item;
  });

  if (!info.dropToGap) {
    // Drop on the content
    loop(data, dropKey, (item: any) => {
      const item2 = item;
      item2.children = item2.children || [];
      // where to insert 示例添加到头部，可以是随意位置
      item2.children.unshift(dragObj);
    });
  } else if (
    (info.node.props.children || []).length > 0 && // Has children
    info.node.props.expanded && // Is expanded
    dropPosition === 1 // On the bottom gap
  ) {
    loop(data, dropKey, (item: any) => {
      const item2 = item;
      item2.children = item2.children || [];
      item2.children.unshift(dragObj);
    });
  } else {
    let ar: any;
    let i: any;
    loop(data, dropKey, (item: any, index: any, arr: any) => {
      ar = arr;
      i = index;
    });
    if (dropPosition === -1) {
      ar.splice(i, 0, dragObj);
    } else {
      ar.splice(i + 1, 0, dragObj);
    }
  }
  return data;
};

const checkDataLoop = (datas: any, key: any) => {
  if (!datas) return [];
  const data = [...datas];
  let arr: any = [];
  for (let index = 0; index < data.length; index++) {
    if (data[index].id === key) {
      if (data[index].children && data[index].children.length > 0) {
        arr = ['halfChecked', key];
      } else {
        arr = ['checked', key];
      }
      break;
    } else {
      if (data[index].children && data[index].children.length > 0) {
        const arr1 = checkDataLoop(data[index].children, key);
        if (arr1.length > 0) {
          arr = arr1;
        }
      }
    }
  }
  return arr;
};

const getAllChildKey = (datas: any) => {
  if (!datas) return [];
  const data = [...datas];
  let arr: any = [];
  data.map((item) => {
    if (item.children && item.children.length > 0) {
      arr = [...arr, ...getAllChildKey(item.children)];
    }
    arr.push(item.id);
  });
  return arr;
};

const checkChildLoop = (datas: any, key: any) => {
  if (!datas) return [];
  const data = [...datas];
  let arr: any = [];
  for (let index = 0; index < data.length; index++) {
    if (data[index].id === key) {
      const arr0 = getAllChildKey(data[index].children);
      arr = arr0;
      break;
    } else {
      const arr1 = checkChildLoop(data[index].children, key);
      if (arr1.length > 0) {
        arr = arr1;
      }
    }
  }
  return arr;
};

// // 树半选中
export const checkLoop = (treeDatas: any[], key: any[]) => {
  const treeData = [...treeDatas];
  const keys = [...key];
  if (!treeData || treeData.length === 0) return [];
  if (!keys || keys.length === 0) return [];
  const result: any = { checked: [], halfChecked: [] };
  keys.forEach((item) => {
    const arr = checkDataLoop(treeData, item);
    if (arr.length > 0) {
      if (arr[0] === 'halfChecked') {
        const child = checkChildLoop(treeData, arr[1]);
        const flag = child.every((val: number) => keys.includes(val));
        if (flag) {
          result.checked.push(arr[1]);
        } else {
          result.halfChecked.push(arr[1]);
        }
      }
      if (arr[0] === 'checked') {
        result.checked.push(arr[1]);
      }
    }
  });
  return result;
};

export const getRedPath = (list: any[]) => {
  if (!list || list.length === 0) return '/';
  let rePath: any;
  for (let index = 0; index < list.length; index++) {
    const item = list[index];
    if (item.hasChild === 0 && !item.hideInMenu) {
      rePath = item.path;
      break;
    } else if (item.hasChild === 1 && item.routes && item.routes.length > 0) {
      const res = getRedPath(item.routes);
      if (res) {
        rePath = item.path + '/' + res;
        break;
      }
    }
  }
  return rePath || '/';
};

// 树 只展示设定的级别
export const filterLevel = (list: any[], level: number): any[] => {
  return list.map((v) => ({
    ...v,
    children: level <= 1 ? [] : filterLevel(v.children, level - 1),
  }));
};

// 树只能选择末级
export const treeSelectLastNode = (tree: any[], childName: string) => {
  if (!tree || tree?.length === 0) return [];
  return tree.map((item) => {
    if (item?.[childName] && item?.[childName]?.length > 0) {
      item.selectable = false;
      item[childName] = treeSelectLastNode(item?.[childName], childName);
    }
    return item;
  });
};

// 下载文件
export const downLoadFile = async (response: any) => {
  console.log(response);

  const blob = await response.clone().blob(); //创建隐藏的可下载链接
  const disposition = response.headers.get('Content-disposition');
  const fileName = disposition.substr(disposition.indexOf('=') + 1);
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  reader.onload = (e: any) => {
    const a = document.createElement('a');
    a.download = decodeURI(fileName); // 下载后文件名
    a.href = e.target.result; // window.URL.createObjectURL(blob)也可 创建下载的链接
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
};

// 菜单只能选中末级
export const menuTreeSelectable = (tree: any[]) => {
  if (!tree || tree.length === 0) return [];
  return tree.map((item: any) => {
    if (item?.children && item?.children?.length > 0) {
      item.selectable = false;
      const arr1 = menuTreeSelectable(item.children);
      item.children = arr1;
    }
    return item;
  });
};

// 寻找菜单树能选中的第一个节点
export const findMenuTreeFirstSelectableNode = (tree: any[]) => {
  if (!tree || tree.length === 0) return [];
  let key: any = '';
  const item = tree[0];
  if (item.permissionMenu === 1) {
    key = item.key;
  }
  if (item.children && item.children.length > 0) {
    key = findMenuTreeFirstSelectableNode(item.children);
  }
  return key;
};

export const findMenuTreeFirstSelectableNodeName = (tree: any[]) => {
  if (!tree || tree.length === 0) return [];
  let title: any = '';
  const item = tree[0];
  if (item.permissionMenu === 1) {
    title = item.title;
  }
  if (item.children && item.children.length > 0) {
    title = findMenuTreeFirstSelectableNodeName(item.children);
  }
  return title;
};

// 获取树所有id
export const getTreeIds = (tree: any[], id?: any) => {
  if (!tree || tree.length === 0) return [];
  let res: any[] = [];
  tree.map((item) => {
    let children = [];
    if (item.children && item.children.length > 0) {
      children = getTreeIds(item.children, id) || [];
    }
    if (id) {
      res = [...res, item[id], ...children];
    } else {
      res = [...res, item.id, ...children];
    }
  });
  return res;
};

export const turnAttachmentsToLocal = (
  list: {
    attachmentName: string;
    attachmentUrl: string;
    fileUrl?: string;
    attachmentType?: string | number;
  }[],
  isPdf?: boolean,
) => {
  return list.map((item) => {
    return {
      ...item,
      name: item.attachmentName,
      url: isPdf ? (item.fileUrl as string) : item.attachmentUrl,
    };
  });
};

export const turnLocalToAttachments = (
  list: {
    name?: string;
    url?: string;
  }[],
) => {
  return list.map((item) => {
    return {
      attachmentName: item.name,
      attachmentUrl: item.url,
    };
  });
};

export function findTreeNodeLabelValue(
  tree: Record<string, any>[],
  keyLabel: string,
  key: string,
  label: string,
  childrenLabel: string = 'children',
) {
  if (!tree || tree?.length === 0) return '';
  let res = '';
  for (let i = 0; i < tree.length; i++) {
    const item = tree[i];
    if (item[keyLabel] === key) {
      res = item[label];
      break;
    } else if (item[childrenLabel] && item[childrenLabel]?.length > 0) {
      const r = findTreeNodeLabelValue(item[childrenLabel], keyLabel, key, label, childrenLabel);
      if (r) {
        res = r;
        break;
      }
    }
  }
  return res;
}

// 查找拖拽节点的父级
const findDropParent = (list: any[], id: React.Key): any => {
  for (const item of list) {
    if (item.key === id) {
      return item;
    }
    if (item?.children?.length > 0) {
      const parent = findDropParent(item.children, id);
      if (parent) return parent;
    }
  }
  return null;
};

export const newDropHandle = (info: any, treeData: any[]) => {
  // console.log(info);
  const dropKey = info.node.key;
  const dragKey = info.dragNode.key;
  // const dropPos = info.node.pos.split('-');
  // const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);

  let data = [];
  // 判断是否为平级移动
  if (info.dropToGap) {
    // 找到拖拽元素所在的父元素
    const parent = findDropParent(treeData, (info.node as any).parentId);
    if (parent) {
      // 将拖拽的元素过滤掉
      data = parent?.children?.filter((item: any) => item.key !== dragKey);
      // 查找需要投放到元素的位置
      const pos = data.findIndex((item: any) => item.key === dropKey);
      // 在该元素后面插入拖拽元素
      data.splice(pos + 1, 0, { ...info.dragNode, parentId: parent.key });
    }
  } else {
    const parent = findDropParent(treeData, info.node.key);
    if (parent) {
      data = [...(parent?.children || [])];
      const dragPos = info.dragNode.pos.split('-');
      dragPos.pop();
      const dragstr = dragPos.toString();
      const dropPos1 = info.node.pos.split('-');
      const dropstr1 = dropPos1.toString();
      if (info.dropPosition === 0 && dragstr === dropstr1) {
        const arr = data.filter((item) => item.key !== info.dragNode.key);
        arr.unshift({ ...info.dragNode, parentId: parent.key });
        data = arr;
      } else {
        data.push({ ...info.dragNode, parentId: parent.key });
      }
    }
  }
  // console.log(data)
  return data;
};

export const uploadFailValidator = (_: unknown, value: { name?: string; url?: string }[]) => {
  if (value && value?.length > 0 && value?.some((item) => !item.url)) {
    return Promise.reject(new Error('文件上传失败'));
  }
  return Promise.resolve();
};

export const amountValidator = (_: unknown, value: number | null | string) => {
  const myRegex = /^[0-9]{1,6}(\.[0-9]{1,6})?$/;
  const isMatch = myRegex.test(value as string);
  if (value && !isMatch) {
    return Promise.reject(new Error('请输入0-999999.999999之间的数值'));
  }
  return Promise.resolve();
};

export const rowAmountValidator = (value: number | null | string) => {
  const myRegex = /^[0-9]{1,6}(\.[0-9]{1,6})?$/;
  const isMatch = myRegex.test(value as string);
  if (value && !isMatch) {
    return true;
  }
  return false;
};

export const progressValidator = (
  _: unknown,
  value: number | null | string,
  before?: string | number | null,
) => {
  const myRegex = /^[0-9]+$/;
  const isMatch = myRegex.test(value as string);
  if (value && (!isMatch || value > 100)) {
    return Promise.reject(new Error('请输入0-100之间的整数'));
  }
  if (before && value) {
    if (typeof before === 'number') {
      if (before > value) {
        return Promise.reject(new Error('累计项目进度不能小于上一次填写的数值'));
      }
    }
    if (typeof before === 'string') {
      const numBefore = new BigNumber(before);
      if (numBefore.toNumber() > value) {
        return Promise.reject(new Error('累计项目进度不能小于上一次填写的数值'));
      }
    }
  }
  return Promise.resolve();
};

export function trimTopic(topic: string) {
  return topic.replace(/[，。！？”“"、,.!?]*$/, '');
}

export function filterHTMLTag(str: string) {
  if (typeof str !== 'string') return '';
  return str.replace(/^\s*[\r\n]/gm, '').replace(/[\r\n]\s+/gi, '\n');
}

export async function copyToClipboard(text: string, filter: boolean = false) {
  const _text = filter ? filterHTMLTag(text) : text;
  try {
    if (window.__TAURI__) {
      window.__TAURI__.writeText(_text);
    } else {
      await navigator.clipboard.writeText(_text);
    }
    message.success(Locale.Copy.Success);
  } catch (error) {
    const textArea = document.createElement('textarea');
    textArea.value = _text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand('copy');
      message.success(Locale.Copy.Success);
    } catch (error) {
      message.error(Locale.Copy.Failed);
    }
    document.body.removeChild(textArea);
  }
}

export function downloadAs(text: string, filename: string) {
  const element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

export function readFromFile() {
  return new Promise<string>((res, rej) => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'application/json';

    fileInput.onchange = (event: any) => {
      const file = event.target.files[0];
      const fileReader = new FileReader();
      fileReader.onload = (e: any) => {
        res(e.target.result);
      };
      fileReader.onerror = (e) => rej(e);
      fileReader.readAsText(file);
    };

    fileInput.click();
  });
}

export function isIOS() {
  const userAgent = navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent);
}

export function useWindowSize() {
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const onResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return size;
}

export const MOBILE_MAX_WIDTH = 600;
export function useMobileScreen() {
  const { width } = useWindowSize();

  return width <= MOBILE_MAX_WIDTH;
}

export function isFirefox() {
  return typeof navigator !== 'undefined' && /firefox/i.test(navigator.userAgent);
}

export function selectOrCopy(el: HTMLElement, content: string, filter?: boolean) {
  const currentSelection = window.getSelection();

  if (currentSelection?.type === 'Range') {
    return false;
  }

  copyToClipboard(content, filter);

  return true;
}

function getOrCreateMeasureDom(
  id: string,
  parent: HTMLElement = document.body,
  isWebapp = false,
  init?: (dom: HTMLElement) => void,
) {
  let dom: HTMLElement | null = parent.querySelector(`#${id}`);

  if (!dom) {
    dom = document.createElement('span');
    dom.style.position = 'absolute';
    dom.style.wordBreak = 'break-word';
    dom.style.fontSize = isWebapp ? '15px' : '18px';
    dom.style.transform = 'translateY(-200vh)';
    dom.style.pointerEvents = 'none';
    dom.style.opacity = '0';
    dom.id = id;
    parent.appendChild(dom);
    init?.(dom);
  }

  return dom!;
}

export function autoGrowTextArea(
  dom: HTMLTextAreaElement,
  isWebapp = false,
  parent: HTMLElement = document.body,
  inShadow = false,
) {
  const measureDom = getOrCreateMeasureDom('__measure', parent, isWebapp);
  const singleLineDom = getOrCreateMeasureDom('__single_measure', parent, isWebapp, (dom) => {
    dom.innerText = 'TEXT_FOR_MEASURE';
  });
  const width = dom.clientWidth;
  measureDom.innerText = dom.value !== '' ? dom.value : '1';
  measureDom.style.padding = !isWebapp
    ? '0 165px 0 16px'
    : inShadow
    ? '0 10px'
    : '4px 46px 4px 11px';
  measureDom.style.width = width + 'px';
  measureDom.style.boxSizing = 'border-box';

  const endWithEmptyLine = dom?.value?.endsWith('\n');
  const height = parseFloat(window.getComputedStyle(measureDom).height);
  const singleLineHeight = parseFloat(window.getComputedStyle(singleLineDom).height);

  const rows = Math.round(height / singleLineHeight) + (endWithEmptyLine ? 1 : 0);

  return rows;
}

export function getCSSVar(varName: string) {
  return getComputedStyle(document.body).getPropertyValue(varName).trim();
}

export const turnTreeList = (tree: any[], pid?: string) => {
  if (!tree || tree?.length === 0) return [];
  return tree?.map((item) => {
    if (item?.userId) {
      item.key = `${item?.userId}`;
      item.title = item?.userName;
      if (pid) {
        item.key = `${pid}_userId_${item?.userId}`;
        item.parentId = pid;
      }
    }
    if (item?.children && item?.children?.length > 0) {
      if (item?.users && item?.users?.length > 0) {
        const arr1 = turnTreeList(item?.children);
        const arr2 = turnTreeList(item?.users, item?.key ? item?.key : item?.userId);
        item.children = [...arr1, ...arr2];
      } else {
        item.children = turnTreeList(item?.children);
      }
    } else if (item?.users && item?.users?.length > 0) {
      item.children = turnTreeList(item?.users, item?.key ? item?.key : item?.userId);
    }
    // console.log(item)
    return item;
  });
};

export const turnEntitySelected = (sels: any[]) => {
  let askEntityIds: string[] = [];
  let userIds: number[] = [];
  if (!sels || sels?.length === 0) return { askEntityIds, userIds };
  sels?.map((item) => {
    if (item?.indexOf('_userId_') >= 0) {
      const i = item?.split('_userId_')?.[1];
      if (i) {
        userIds?.push(parseFloat(i));
      }
    } else {
      askEntityIds?.push(item);
    }
    return undefined;
  });
  return { askEntityIds, userIds };
};
